import React from 'react';
// import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Image from '../fl-components/Image';
import EmptyData from '../image/empty-box.png';
// import animationData from '../image/empty_data.json';

export default function EmptyDashboardChart({ text }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      pt="20%"
    >
      <Image
        src={EmptyData}
        sx={{
          height: 150,
          width: 250,
          textAlign: 'center',
          '& .wrapper': {
            width: 'unset',
            height: '100%'
          }
        }}
        imageStyle={{ height: '100%', width: 'unset' }}
      />
      {/* <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData
        }}
        height={150}
        width={250}
        style={{ marginTop: '-30px', marginBottom: '-20px', cursor: 'default' }}
        isClickToPauseDisabled
      /> */}
      <Typography variant="subtitle1" noWrap>
        {text || `Oops seems like no data available`}
      </Typography>
    </Box>
  );
}

EmptyDashboardChart.propTypes = {
  text: PropTypes.string
};
